import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  text-align: left;
  padding: 20px;
  overflow: auto;
  @media only screen and (max-width: 500px) {
    padding-top: 60px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
`;

export const Main = styled.div`
  align-items: center;
  border-bottom: 1ps solid #666;
  padding: 10px;
`;

export const Title = styled.h1`
  text-align: left;
  color: #0083ff;
  font-size: 18px;
  width: 200px;
`;

export const Header = styled.div`
  flex: 1;
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 20px;
`;

export const Footer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1ps solid #666;
  margin-top: 20px;
  border-top: 1px solid #d3d3d3;
  padding: 10px;
`;

export const Button = styled.button`
  background: #ff8800;
  color: white;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  height: 30px;
  padding: 0 20px;
`;
